import {httpGet,httpPut,httpDelete,httpPost} from '../../../../util/request.js';
import appConfig from '../../../../config';

export default class BackendPrintApi{

    static QUERY_BACKENDPRINT_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/crm/printcoupon/backendPrints";
    static SAVE_BACKENDPRINT_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/crm/printcoupon/backendPrint";
    static GET_BACKENDPRINT_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/crm/printcoupon/backendPrint";
    static BACKEND_REPRINT_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/crm/printcoupon/backendReprint";

    //static QUERY_GIVE_COUPON_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/printcoupon/givecoupons";
	
	static queryBackendPrint(params){
		return httpGet(BackendPrintApi.QUERY_BACKENDPRINT_API_URL,params);
    }

    static getBackendPrint(params){
		return httpGet(BackendPrintApi.GET_BACKENDPRINT_API_URL,params);
    }

    static saveBackendPrint(params){
		return httpPost(BackendPrintApi.SAVE_BACKENDPRINT_API_URL,params);
    }

    static backendReprint(params){
		return httpPost(BackendPrintApi.BACKEND_REPRINT_API_URL,params);
    }

    // static queryGiveCoupon(params){
	// 	return httpGet(BackendPrintApi.QUERY_GIVE_COUPON_API_URL,params);
    // }
    
    /*

	static stopAppoint(appoint){
		let params={appoint:appoint};
		return httpPost(AppointApi.STOP_APPOINT_API_URL,params);
	}

	static restoreAppoint(appoint){
		let params={appoint:appoint};
		return httpPost(AppointApi.RESTORE_APPOINT_API_URL,params);
	}
	
	static insertAppoint(appoint){
		let params={appoint:appoint};
		return httpPost(AppointApi.INSERT_APPOINT_API_URL,params);
	}
	
    */
	
}